export const API_URL = 'https://api.scholarbee.pk/api';
export const API_URL_DEV = 'https://api-dev.scholarbee.pk/api';
export const S3_URL = 'https://scolarbee-s3-bucket.s3.us-east-1.amazonaws.com/';
